export default __webpack_public_path__ + "static/meet-john-1-1ed7ef793de510449f450ecd24387458.webp";